export default "__VITE_ASSET__D2PpWV8___"